
import { lazy } from "react";
import HostLayout from "@/layouts/HostLayout";
import { createRoutesConfig } from "@/utils/routeUtils";

// Lazy load host pages
const HostDashboardPage = lazy(() => import("@/pages/host/HostDashboardPage"));
const HostPropertiesPage = lazy(() => import("@/pages/host/HostPropertiesPage"));
const AddPropertyPage = lazy(() => import("@/pages/host/AddPropertyPage"));
const EditPropertyPage = lazy(() => import("@/pages/host/EditPropertyPage"));
const HostBookingsPage = lazy(() => import("@/pages/host/HostBookingsPage"));
const HostMessagesPage = lazy(() => import("@/pages/host/HostMessagesPage"));
const HostEarningsPage = lazy(() => import("@/pages/host/HostEarningsPage"));
const HostSettingsPage = lazy(() => import("@/pages/host/HostSettingsPage"));
const HostAnalyticsPage = lazy(() => import("@/pages/host/HostAnalyticsPage"));
const HostOnboardingPage = lazy(() => import("@/pages/host/HostOnboardingPage"));
const HostPaymentMethodsPage = lazy(() => import("@/pages/host/HostPaymentMethodsPage"));
const AddPaymentMethodPage = lazy(() => import("@/pages/host/AddPaymentMethodPage"));
const HostVerificationPage = lazy(() => import("@/pages/host/HostVerificationPage"));
const AIAssistantPage = lazy(() => import("@/pages/host/AIAssistantPage"));

// Create base host routes configuration
const hostRoutesConfig = createRoutesConfig("/host", <HostLayout />, "host");

// Define host routes
export const hostRoutes = {
  ...hostRoutesConfig,
  children: [
    { path: "", element: <HostDashboardPage /> },
    { path: "properties", element: <HostPropertiesPage /> },
    { path: "properties/add", element: <AddPropertyPage /> },
    { path: "properties/edit/:id", element: <EditPropertyPage /> },
    { path: "bookings", element: <HostBookingsPage /> },
    { path: "messages", element: <HostMessagesPage /> },
    { path: "earnings", element: <HostEarningsPage /> },
    { path: "settings", element: <HostSettingsPage /> },
    { path: "analytics", element: <HostAnalyticsPage /> },
    { path: "onboarding", element: <HostOnboardingPage /> },
    { path: "payment-methods", element: <HostPaymentMethodsPage /> },
    { path: "add-payment-method", element: <AddPaymentMethodPage /> },
    { path: "verification", element: <HostVerificationPage /> },
    { path: "ai-assistant", element: <AIAssistantPage /> },
  ],
};
